// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Env from "./Env.res.js";
import * as Auth from "../bundles/Auth/Auth.res.js";
import * as React from "react";
import * as AuthRoutes from "../app/Auth/AuthRoutes.res.js";
import * as BugTracker from "./BugTracker.res.js";
import * as Navigation from "../primitives/Navigation.res.js";
import * as PosthogJs from "posthog-js";
import * as ApolloClient from "rescript-apollo-client/src/ApolloClient.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OperationDurations from "./OperationDurations.res.js";
import * as React$1 from "@apollo/client/react";
import * as ApolloClient__Utilities from "rescript-apollo-client/src/@apollo/client/utilities/ApolloClient__Utilities.res.js";
import * as ApolloClient__Link_Error from "rescript-apollo-client/src/@apollo/client/link/error/ApolloClient__Link_Error.res.js";
import * as ApolloClient__ZenObservable from "rescript-apollo-client/src/zen-observable/ApolloClient__ZenObservable.res.js";
import * as ReasonMLCommunity__ApolloClient from "rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.res.js";
import * as ApolloClient__Link_Http_HttpLink from "rescript-apollo-client/src/@apollo/client/link/http/ApolloClient__Link_Http_HttpLink.res.js";
import * as ApolloClient__Cache_InMemory_InMemoryCache from "rescript-apollo-client/src/@apollo/client/cache/inmemory/ApolloClient__Cache_InMemory_InMemoryCache.res.js";

let fetcher = ((...args) => window.fetch(...args));

let match = Env.context();

let httpGatewayLink = match === "test" ? ApolloClient__Link_Http_HttpLink.make(param => "http://localhost/graphql", undefined, undefined, undefined, undefined, undefined, undefined, undefined) : ApolloClient__Link_Http_HttpLink.make(param => Env.gatewayUrl() + "/graphql", undefined, Primitive_option.some(fetcher), undefined, undefined, undefined, undefined, undefined);

let match$1 = Env.context();

let httpAnalyticsLink = match$1 === "test" ? ApolloClient__Link_Http_HttpLink.make(param => "http://localhost/graphql", undefined, undefined, undefined, undefined, undefined, undefined, undefined) : ApolloClient__Link_Http_HttpLink.make(param => Env.analyticsUrl() + "/graphql", undefined, Primitive_option.some(fetcher), undefined, undefined, undefined, undefined, undefined);

let terminatingLink = ReasonMLCommunity__ApolloClient.Link.split(param => {
  let match = ApolloClient__Utilities.getOperationDefinition(param.query);
  if (match === undefined) {
    return false;
  }
  let match$1 = match.name;
  if (match$1 !== undefined && match.kind === "OperationDefinition" && match.operation === "query") {
    return match$1.value.startsWith("Analytics");
  } else {
    return false;
  }
}, httpAnalyticsLink, httpGatewayLink);

let authMiddleware = ReasonMLCommunity__ApolloClient.Link.make((operation, forward) => {
  let jwt = Auth.getJwt();
  if (jwt !== undefined) {
    operation.setContext(Auth.encodeHttpContext(jwt));
  }
  return ApolloClient__ZenObservable.Observable.fromJs(forward(operation));
});

function errorMiddleware() {
  return ApolloClient__Link_Error.ErrorLink.make(errors => {
    let errors$1 = errors.graphQLErrors;
    if (errors$1 !== undefined) {
      errors$1.forEach(err => {
        let exn = err.originalError;
        if (!(exn == null)) {
          BugTracker.reportException(exn);
          PosthogJs.default.captureException(exn);
          return;
        }
      });
    }
    let error = errors.networkError;
    if (error !== undefined) {
      switch (error.TAG) {
        case "FetchFailure" :
          let exn = error._0;
          BugTracker.reportException(exn);
          PosthogJs.default.captureException(exn);
          break;
        case "BadStatus" :
          if (error._0 !== 401) {
            
          } else {
            Navigation.openRoute(AuthRoutes.logoutSessionExpiredRoute);
          }
          break;
        case "BadBody" :
          break;
      }
    }
  });
}

function makeClient() {
  return ApolloClient.make(undefined, undefined, undefined, Primitive_option.some(ReasonMLCommunity__ApolloClient.Link.from([
    errorMiddleware(),
    authMiddleware,
    OperationDurations.link,
    terminatingLink
  ])), ApolloClient__Cache_InMemory_InMemoryCache.make(undefined, undefined, undefined, undefined, undefined, undefined), undefined, undefined, Env.context() === "dev", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

function ApolloConfig$Provider(props) {
  let authState = Auth.useState();
  let client = makeClient();
  React.useEffect(() => {
    if (typeof authState !== "object") {
      client.rescript_clearStore();
    } else {
      authState.TAG === "Logging";
    }
  }, [authState]);
  return JsxRuntime.jsx(React$1.ApolloProvider, {
    client: client,
    children: props.children
  });
}

let Provider = {
  make: ApolloConfig$Provider
};

let edgesPerFetchLimit = 50;

let mutationDebounceInterval = 750;

export {
  edgesPerFetchLimit,
  mutationDebounceInterval,
  makeClient,
  Provider,
}
/* match Not a pure module */
